/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import moment from 'moment-timezone';
import SelectReasonCodes from 'components/modules/marketplace-config/SelectReasonCodes';
import DatePicker from 'components/v2/DatePicker';
import { getTimezones } from 'utils/Timezones';
import { getTimezone } from 'helpers/stops';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticSelect from 'components/v2/select';
import CustomDateInput from 'components/v2/CustomDateInput';
import { getShipment } from 'utils/ShipmentWebAPIUtils';
import { processDateTimeChange } from 'utils/formatters/Date';
import TimePicker from 'components/v2/TimePicker';
import SoftAlertHoldNotification from 'components/modules/shipments/stops/SoftAlertHoldNotification';
import CargomaticModal from '../../../v2/modal';
function ArrivalFormFooter({ disabled, onSave, onCancel, t }) {
    return ((React.createElement("div", { "data-testid": "div-cc35a744", className: "flex justify-end items-center space-x-2" },
        React.createElement("button", { "data-testid": "button-c220c15c", className: "button button-green", onClick: onSave, disabled: disabled }, titleize(t('SAVE'))),
        React.createElement("button", { "data-testid": "button-ed67a0cd", className: "button button-secondary", onClick: onCancel }, titleize(t('CANCEL'))))));
}
function getArrivalDefaultDate(stop) {
    if (!stop)
        return '';
    const { window_start } = stop;
    return window_start && moment().isAfter(window_start)
        ? moment(window_start).tz(getTimezone(stop))
        : moment().tz(getTimezone(stop));
}
class StopArrivedModal extends Component {
    constructor(props) {
        super(props);
        this.fetchShipment = async (shipmentId, stopId) => {
            var _a;
            try {
                const result = await getShipment(shipmentId);
                const shipment = (_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.item;
                const stop = shipment === null || shipment === void 0 ? void 0 : shipment.stops.find((s) => s._id === stopId);
                const { meta } = this.state;
                meta.timezone = getTimezone(stop);
                meta.date = getArrivalDefaultDate(stop);
                meta.time = stop ? getArrivalDefaultDate(stop).format('hh:mm A') : '';
                this.setState({
                    shipment,
                    stop,
                    meta,
                });
            }
            catch (e) {
                console.error(e);
            }
        };
        this.setCodesRequired = (requireCodes) => {
            this.setState({ requireCodes });
        };
        this.handleDateChange = (value) => {
            this.setState((prevState) => {
                const result = processDateTimeChange({
                    date: value,
                    time: prevState.meta.time,
                    timezone: prevState.meta.timezone,
                });
                const { date, isDateInvalid, validTimeEntered, validDateEntered, usingFutureDate, } = result;
                const meta = Object.assign(Object.assign({}, prevState.meta), { date, dateChanged: true });
                return {
                    meta,
                    validDateEntered,
                    validTimeEntered,
                    isDateInvalid,
                    usingFutureDate,
                };
            });
        };
        this.handleTimezoneChange = (zone) => {
            const timezone = zone.value;
            this.setState((prevState) => {
                const result = processDateTimeChange({
                    date: prevState.meta.date,
                    time: prevState.meta.time,
                    timezone,
                });
                const { date, isDateInvalid, validTimeEntered, validDateEntered, usingFutureDate, } = result;
                const meta = Object.assign(Object.assign({}, prevState.meta), { date,
                    timezone });
                return {
                    meta,
                    validDateEntered,
                    validTimeEntered,
                    isDateInvalid,
                    usingFutureDate,
                };
            });
        };
        this.handleTimeChange = (e) => {
            const { target: { value: time }, } = e;
            this.setState((prevState) => {
                const result = processDateTimeChange({
                    date: prevState.meta.date,
                    time,
                    timezone: prevState.meta.timezone,
                });
                const { date, isDateInvalid, validTimeEntered, validDateEntered, usingFutureDate, } = result;
                const meta = Object.assign(Object.assign({}, prevState.meta), { date,
                    time, timeChanged: true });
                return {
                    meta,
                    validDateEntered,
                    validTimeEntered,
                    isDateInvalid,
                    usingFutureDate,
                };
            });
        };
        this.handleReasonSelect = (item) => {
            const { meta } = this.state;
            meta.reason = item;
            this.setState({ meta });
        };
        this.handleCommentInput = (comment) => {
            const { meta } = this.state;
            meta.comment = comment;
            if (comment.length) {
                meta.commentRequired = false;
            }
            this.setState({ meta });
        };
        this.handleCommentRequired = (value) => {
            const { t } = this.props;
            const { meta } = this.state;
            meta.commentRequired = value;
            if (value) {
                meta.error = t('CUSTOM_REASON_CODE_REQUIRE_COMMENT');
            }
            this.setState({ meta });
        };
        this.handleComplete = () => {
            const { shipment, stop, meta } = this.state;
            meta.date = moment(meta.date).toISOString();
            this.props.onStopArrived(shipment, stop, 'arrived', meta);
            this.setState({ meta: {} }, () => {
                this.props.onHide();
            });
        };
        this.handleHide = () => {
            this.setState({ meta: {} }, () => {
                this.props.onHide();
            });
        };
        this.isValid = () => {
            const { meta, requireCodes, usingFutureDate, isDateInvalid } = this.state;
            const { reason, comment, commentRequired, dateChanged, timeChanged } = meta;
            if (usingFutureDate) {
                return false;
            }
            if (!dateChanged || !timeChanged) {
                return false;
            }
            if (isDateInvalid) {
                return false;
            }
            if (requireCodes) {
                if (!reason) {
                    return false;
                }
                if (commentRequired && (!comment || !comment.length)) {
                    return false;
                }
            }
            return true;
        };
        this.state = {
            shipment: props.shipment,
            stop: props.stop,
            meta: {
                date: getArrivalDefaultDate(props.stop),
                timezone: props.stop ? getTimezone(props.stop) : null,
                time: props.stop
                    ? getArrivalDefaultDate(props.stop).format('hh:mm A')
                    : '',
                reason: null,
                comment: '',
                commentRequired: false,
                timeChanged: false,
                dateChanged: false,
            },
            requireCodes: false,
            usingFutureDate: false,
            validDateEntered: false,
            validateTimeEntered: false,
            isDateInvalid: false,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.shipment && nextProps.stop) {
            this.setState({
                shipment: nextProps.shipment,
                stop: nextProps.stop,
            });
        }
        else {
            this.fetchShipment(nextProps.shipmentId, nextProps.stopId);
        }
    }
    componentDidMount() {
        const { shipmentId, stopId } = this.props;
        if (!this.state.shipment || !this.state.stop)
            this.fetchShipment(shipmentId, stopId);
    }
    renderSoftAlertForHolds() {
        const { shipment } = this.state;
        if (!shipment || !shipment.holds)
            return null;
        return React.createElement(SoftAlertHoldNotification, { shipment: shipment });
    }
    render() {
        const { t } = this.props;
        return ((React.createElement(CargomaticModal, { dataTestId: "CargomaticModal-9ae6fef4", backdrop: "static", title: t('ARRIVAL_INFO'), showCloseButton: true, show: this.props.show, onHide: this.handleHide, footer: React.createElement(ArrivalFormFooter, { disabled: !this.isValid(), onSave: this.handleComplete, onCancel: this.handleHide, t: t }) },
            !this.state.shipment && React.createElement("p", { "data-testid": "p-4f1859c3" }, t('LOADING')),
            this.state.stop && this.state.shipment && (React.createElement(React.Fragment, null,
                this.renderSoftAlertForHolds(),
                React.createElement("label", { "data-testid": "label-2689884b", htmlFor: "arrival-date", className: "form-label mb-1" }, t('DATE_AND_TIME_STOP_MESSAGE')),
                React.createElement("div", { "data-testid": "div-dd7bf305", className: "flex flex-wrap items-center -mx-2" },
                    React.createElement("div", { "data-testid": "div-ee1c2cd3", className: "px-2" },
                        React.createElement(DatePicker, { dataTestId: "DatePicker-0a335a49", placeholderText: t('ARRIVAL_DATE'), selected: this.state.meta.dateChanged && this.state.meta.date, onChange: (selectedDate) => {
                                this.handleDateChange(selectedDate);
                            }, onChangeRaw: (e) => {
                                this.handleDateChange(e.target.value);
                            }, isClearable: true })),
                    React.createElement("div", { "data-testid": "div-250b85fb", className: "px-2" },
                        React.createElement(TimePicker, { dataTestId: "TimePicker-5da94a5c", value: this.state.meta.timeChanged && this.state.meta.time, onChange: this.handleTimeChange })),
                    React.createElement("div", { "data-testid": "div-a2e6d4b6", className: "px-2" },
                        React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-819223a2", hideLabel: true, onSelect: this.handleTimezoneChange, items: getTimezones(), value: this.state.meta.timezone, valueKey: "value", textKey: "name" }))),
                this.state.usingFutureDate && (React.createElement("div", { "data-testid": "div-97db14b1", className: "text-red text-sm mt-1" }, t('COMPLETION_DATE_FUTURE_WARNING'))),
                React.createElement("div", { "data-testid": "div-74a34f76", className: "mt-4" },
                    React.createElement(SelectReasonCodes, { shipment: this.state.shipment, category: "stop_arrival", updateComment: this.handleCommentInput, selectReasonCode: this.handleReasonSelect, updateCommentRequired: this.handleCommentRequired, setCodesRequired: this.setCodesRequired })))))));
    }
}
export default withTranslation()(StopArrivedModal);
